// ...existing code...
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import PageCard from './components/PageCard';
import { formatCurrencyView } from './utils/currencyUtils';

function MovimentoMensal() {
  const [rendimentos, setRendimentos] = useState([]);
  const [despesas, setDespesas] = useState([]);
  const [receitas, setReceitas] = useState([]);
  const [dadosResumo, setDadosResumo] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const anoBase = localStorage.getItem('anoBase') || new Date().getFullYear().toString();
  const anoAtual = new Date().getFullYear();
  // Ano atual: botões até o mês corrente. Demais anos: janeiro a dezembro.
  const maxMes = parseInt(anoBase, 10) === anoAtual ? new Date().getMonth() + 1 : 12;
  const [mesSelecionado, setMesSelecionado] = useState(
    parseInt(anoBase, 10) === anoAtual ? new Date().getMonth() + 1 : 12
  );

  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');

  const meses = [
    { num: 1, nome: 'Janeiro', campo: 'janeiro' },
    { num: 2, nome: 'Fevereiro', campo: 'fevereiro' },
    { num: 3, nome: 'Março', campo: 'marco' },
    { num: 4, nome: 'Abril', campo: 'abril' },
    { num: 5, nome: 'Maio', campo: 'maio' },
    { num: 6, nome: 'Junho', campo: 'junho' },
    { num: 7, nome: 'Julho', campo: 'julho' },
    { num: 8, nome: 'Agosto', campo: 'agosto' },
    { num: 9, nome: 'Setembro', campo: 'setembro' },
    { num: 10, nome: 'Outubro', campo: 'outubro' },
    { num: 11, nome: 'Novembro', campo: 'novembro' },
    { num: 12, nome: 'Dezembro', campo: 'dezembro' },
  ];

  const carregarDados = async () => {
    setLoading(true);
    try {
      const [resumoRes, rendimentosRes, despesasRes, receitasRes] = await Promise.all([
        axios.get(`${API_BASE_URL.MOVIMENTO}/mensal`, {
          params: { cnpjAssociacao: cnpj, ano: anoBase, mes: mesSelecionado },
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${API_BASE_URL.RENDIMENTO}/all`, {
          params: { cnpjAssociacao: cnpj, ano: anoBase },
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${API_BASE_URL.DESPESA}/all`, {
          params: { cnpjAssociacao: cnpj, ano: anoBase },
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${API_BASE_URL.RECEITA}/all`, {
          params: { cnpjAssociacao: cnpj, ano: anoBase },
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      setDadosResumo(resumoRes.data);
      setRendimentos(Array.isArray(rendimentosRes.data) ? rendimentosRes.data : []);
      setDespesas(Array.isArray(despesasRes.data) ? despesasRes.data : []);
      setReceitas(Array.isArray(receitasRes.data) ? receitasRes.data : []);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      setDadosResumo(null);
      setRendimentos([]);
      setDespesas([]);
      setReceitas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarDados();
  }, [token, cnpj, mesSelecionado]);

  const totalReceitasAteMes = dadosResumo?.receitas?.total ?? 0;
  const totalReceitasAcumulado = dadosResumo?.receitas?.acumulado ?? 0;
  const totalReceitasMes = dadosResumo?.receitas?.mes ?? 0;
  const totalRendimentosAteMes = dadosResumo?.rendimentos?.total ?? 0;
  const totalRendimentosAcumulado = dadosResumo?.rendimentos?.acumulado ?? 0;
  const totalRendimentosMes = dadosResumo?.rendimentos?.mes ?? 0;
  const totalDespesasAteMes = dadosResumo?.despesas?.total ?? 0;
  const totalDespesasAcumulado = dadosResumo?.despesas?.acumulado ?? 0;
  const totalDespesasMes = dadosResumo?.despesas?.mes ?? 0;
  const saldoAteMes = dadosResumo?.saldo?.total ?? 0;
  const saldoAcumulado = dadosResumo?.saldo?.acumulado ?? 0;
  const saldo = dadosResumo?.saldo?.mes ?? 0;

  const mesAtual = meses.find(m => m.num === mesSelecionado);

  return (
    <PageCard title="Movimento Mensal" icon="bi-calendar-month" scrollable={true}>
            {/* Filtros */}
            <div className="row g-2 mb-3">
              <div className="col-md-8 d-flex align-items-center">
                <label className="form-label fw-bold me-2 mb-0">Mês</label>
                <div className="d-flex flex-nowrap gap-1 align-items-center flex-grow-1" style={{ overflowX: 'auto' }}>
                  {meses.map(mes => (
                    <button
                      key={mes.num}
                      type="button"
                      className={`btn btn-sm flex-fill ${mesSelecionado === mes.num ? 'btn-success' : 'btn-outline-success'}`}
                      style={{ minWidth: 44 }}
                      disabled={mes.num > maxMes}
                      onClick={() => setMesSelecionado(mes.num)}
                    >
                      {mes.nome.substring(0, 3)}
                    </button>
                  ))}
                </div>
              </div>
              {/* Ano removido: sempre usa anoBase */}
            </div>

            {/* Resumo */}
            {!isLoading && (
              <>
                <div className="row g-3 mb-3">
                  <div className="col-md-3">
                    <div className="card border-info">
                      <div className="card-body text-center">
                        <i className="bi bi-graph-up text-info fs-1"></i>
                        <h6 className="text-muted mt-2 mb-1">Receitas</h6>
                        <div className="mb-1">
                          <span className="ms-1 fs-4 text-primary fw-bold">{formatCurrencyView(totalReceitasAteMes)}</span>
                        </div>
                        <div className="mb-1">
                          <span className="fw-bold">Acumulado:</span> {formatCurrencyView(totalReceitasAcumulado)}
                        </div>
                        <div>
                          <span className="fw-bold">Mês:</span> {formatCurrencyView(totalReceitasMes)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card border-success">
                      <div className="card-body text-center">
                        <i className="bi bi-piggy-bank text-success fs-1"></i>
                        <h6 className="text-muted mt-2 mb-1">Rendimentos</h6>
                        <div className="mb-1">
                          <span className="ms-1 fs-4 text-success fw-bold">{formatCurrencyView(totalRendimentosAteMes)}</span>
                        </div>
                        <div className="mb-1">
                          <span className="fw-bold">Acumulado:</span> {formatCurrencyView(totalRendimentosAcumulado)}
                        </div>
                        <div>
                          <span className="fw-bold">Mês:</span> {formatCurrencyView(totalRendimentosMes)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card border-danger">
                      <div className="card-body text-center">
                        <i className="bi bi-graph-down text-danger fs-1"></i>
                        <h6 className="text-muted mt-2 mb-1">Despesas</h6>
                        <div className="mb-1">
                          <span className="ms-1 fs-4 text-danger fw-bold">{formatCurrencyView(totalDespesasAteMes)}</span>
                        </div>
                        <div className="mb-1">
                          <span className="fw-bold">Acumulado:</span> {formatCurrencyView(totalDespesasAcumulado)}
                        </div>
                        <div>
                          <span className="fw-bold">Mês:</span> {formatCurrencyView(totalDespesasMes)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className={`card border-${saldo >= 0 ? 'primary' : 'warning'}`}>
                      <div className="card-body text-center">
                        <i className={`bi bi-calculator text-${saldo >= 0 ? 'primary' : 'warning'} fs-1`}></i>
                        <h6 className="text-muted mt-2 mb-1">Saldo</h6>
                        <div className="mb-1">
                          <span className={`ms-1 fs-4 fw-bold text-${saldoAteMes >= 0 ? 'primary' : 'warning'}`}>{formatCurrencyView(saldoAteMes)}</span>
                        </div>
                        <div className="mb-1">
                          <span className="fw-bold">Acumulado:</span> {formatCurrencyView(saldoAcumulado)}
                        </div>
                        <div>
                          <span className="fw-bold">Mês:</span> {formatCurrencyView(saldo)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Detalhamento por conta - Rendimentos */}
                <div className="accordion mb-3" id="accordionMovimento">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseRendimentos"
                        aria-expanded="true"
                      >
                        <i className="bi bi-piggy-bank me-2 text-success"></i>
                        Detalhamento de Rendimentos
                      </button>
                    </h2>
                    <div
                      id="collapseRendimentos"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionMovimento"
                    >
                      <div className="accordion-body">
                        <div className="table-responsive">
                          <table className="table table-sm table-hover">
                            <thead className="table-light">
                              <tr>
                                <th>Conta</th>
                                <th className="text-end">Valor</th>
                              </tr>
                            </thead>
                            <tbody>
                              {rendimentos.map((r, idx) => {
                                const valor = r[mesAtual?.campo] || 0;
                                if (valor === 0) return null;
                                return (
                                  <tr key={idx}>
                                    <td>{r.numConta}</td>
                                    <td className="text-end text-success fw-bold">
                                      {formatCurrencyView(valor)}
                                    </td>
                                  </tr>
                                );
                              })}
                              {rendimentos.filter(r => (r[mesAtual?.campo] || 0) > 0).length === 0 && (
                                <tr>
                                  <td colSpan="2" className="text-center text-muted">
                                    Nenhum rendimento neste mês
                                  </td>
                                </tr>
                              )}
                            </tbody>
                            <tfoot className="table-light fw-bold">
                              <tr>
                                <td>Total</td>
                                 <td className="text-end text-success">
                                   {formatCurrencyView(totalRendimentosMes)}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Detalhamento - Receitas */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseReceitas"
                      >
                        <i className="bi bi-graph-up me-2 text-info"></i>
                        Detalhamento de Receitas
                      </button>
                    </h2>
                    <div
                      id="collapseReceitas"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionMovimento"
                    >
                      <div className="accordion-body">
                        <div className="table-responsive">
                          <table className="table table-sm table-hover">
                            <thead className="table-light">
                              <tr>
                                <th>Data</th>
                                <th>Descrição</th>
                                <th>Fonte</th>
                                <th className="text-end">Valor</th>
                              </tr>
                            </thead>
                            <tbody>
                              {receitas
                                .filter(r => {
                                  const [ano, mesStr, dia] = r.data.split('-');
                                  return parseInt(mesStr, 10) === mesSelecionado;
                                })
                                .map((r, idx) => (
                                  <tr key={idx}>
                                    <td>
                                      {new Date(r.data + 'T00:00:00').toLocaleDateString('pt-BR')}
                                    </td>
                                    <td>{r.descricao}</td>
                                    <td>{r.idFonteRecurso}</td>
                                    <td className="text-end text-info fw-bold">
                                      {formatCurrencyView(r.valor)}
                                    </td>
                                  </tr>
                                ))}
                              {receitas.filter(r => {
                                const [ano, mesStr, dia] = r.data.split('-');
                                return parseInt(mesStr, 10) === mesSelecionado;
                              }).length === 0 && (
                                <tr>
                                  <td colSpan="4" className="text-center text-muted">
                                    Nenhuma receita neste mês
                                  </td>
                                </tr>
                              )}
                            </tbody>
                            <tfoot className="table-light fw-bold">
                              <tr>
                                <td colSpan="3">Total</td>
                                <td className="text-end text-info">
                                  {formatCurrencyView(totalReceitasMes)}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Detalhamento - Despesas */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseDespesas"
                      >
                        <i className="bi bi-graph-down me-2 text-danger"></i>
                        Detalhamento de Despesas
                      </button>
                    </h2>
                    <div
                      id="collapseDespesas"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionMovimento"
                    >
                      <div className="accordion-body">
                        <div className="table-responsive">
                          <table className="table table-sm table-hover">
                            <thead className="table-light">
                              <tr>
                                <th>Data</th>
                                <th>Descrição</th>
                                <th>Favorecido</th>
                                <th>Programa</th>
                                <th className="text-end">Valor</th>
                              </tr>
                            </thead>
                            <tbody>
                              {despesas
                                .filter(d => {
                                  if (!d.dataPagamento) return false;
                                  const [ano, mesStr, dia] = d.dataPagamento.split('-');
                                  return parseInt(mesStr, 10) === mesSelecionado;
                                })
                                .map((d, idx) => (
                                  <tr key={idx}>
                                    <td>
                                      {new Date(d.dataPagamento + 'T00:00:00').toLocaleDateString('pt-BR')}
                                    </td>
                                    <td>{d.objetoResumido || d.objetoDetalhado || '-'}</td>
                                    <td>{d.nomeFavorecido || d.idFavorecido || '-'}</td>
                                    <td>{d.descricaoPrograma || '-'}</td>
                                    <td className="text-end text-danger fw-bold">
                                      {formatCurrencyView(d.valor)}
                                    </td>
                                  </tr>
                                ))}
                              {despesas.filter(d => {
                                if (!d.dataPagamento) return false;
                                const [ano, mesStr, dia] = d.dataPagamento.split('-');
                                return parseInt(mesStr, 10) === mesSelecionado;
                              }).length === 0 && (
                                <tr>
                                  <td colSpan="5" className="text-center text-muted">
                                    Nenhuma despesa paga neste mês
                                  </td>
                                </tr>
                              )}
                            </tbody>
                            <tfoot className="table-light fw-bold">
                              <tr>
                                <td colSpan="4">Total</td>
                                <td className="text-end text-danger">
                                  {formatCurrencyView(totalDespesasMes)}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {isLoading && (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
              </div>
            )}
    </PageCard>
  );
}

export default MovimentoMensal;
